export default class ElementTypeModel {
    idNTipoElemento: number | null;
    fkNVersion: number | null; 
    fldTNombre: string | null;
    fkNIcono: number | null;
    fldNOrden: number | null;
    fldTStyle: string | null;

    constructor() {
        this.idNTipoElemento = null;
        this.fkNVersion = null;
        this.fldTNombre = null;
        this.fkNIcono = null;
        this.fldNOrden = null;
        this.fldTStyle = null;
    }
}